import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDates } from "../../../../../hooks/useDates";
import GenericPromises from "../../../../../api/GenericPromises";
import { useFormatNumber } from "../../../../../hooks/useFormatNumber";
import { useParamsFilter } from "../../../../../hooks/useParamsFilter";
import { useCallback, useEffect, useState } from "react";
import { GridColDef, GridRowSelectionModel, GridRowsProp } from "@mui/x-data-grid";
import { Menuitem } from "../../../../../interfaces/Security/menu";
import useSnackBar from "../../../../../components/Commons/SnackBar/useSnackBar";
import { usePermissions } from "../../../../../hooks/usePermissions";
import { Backdrop, Box, Button, CircularProgress } from "@mui/material";
import { DialogEntity } from "../../../../../components/Dialogs/DialogEntity";
import { Spinner } from "../../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../../components/Header";
import { ButtonStyled, PrimaryButton } from "../../../../../theme/buttons";
import MoneyIcon from '@mui/icons-material/Money';
import EmailIcon from '@mui/icons-material/Email';
import { PaymentDetail } from "../../../../../interfaces/Purchases/Payments/payments";
import { DialogPayment } from "../../DialogPayment";
import { ViewPaymentDetails } from "../view";
import { DialogSendEmailsTable } from "../../helpers/dialogSendEmailTable";
import { useBase64 } from "../../../../../hooks/useBase64";
import { TableCurrencyCompany } from "../../../../../components/Tables/TableCurrencyCompany/tableCurrencies";
import { useCurrencies } from "../../../../../hooks/useCurrencies";
import { useGridPreferences } from "../../../../../hooks/useGridPreferences";
import { AxiosError } from "axios";
import { ErrorDisplay } from "../../../../../components/Commons/Error/ErrorDisplay";
import { usePreferenceTypesStore } from "../../../../../store/Preferences/PreferencesStore";
import { PreferenceType } from "../../../../../interfaces/Commons/Preferences/preferences";
import { usePaymentDetailsColumns } from "./columns";
import DataTableSticky from "../../../../../components/Tables/GridTableMaterialUI/DataTableSticky";
import { FilterTable } from "../../../../../components/Filter";

interface MyTableCurrencyBanks {
  currency_id: number,
  currency_code: string,
  currency_description: string,
  balanceBankAccount: number,
  balanceAutorized: number,
  balanceFree: number,
  exchangeRate: number,
  active: boolean
}

export const TablePaymentsDetails = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const { TimeConverter } = useDates();
  const { GenericGetResource, GenericGetResourceGeneric } = GenericPromises();
  const { setFormatNumberFromTable } = useFormatNumber();
  const { ConvertParamsToBase64 } = useParamsFilter();
  const { utf8ToBase64 } = useBase64();
  const {
    LoadColumnsOrder,
    LoadColumnsVisible,
    LoadColumnsSort,
    VerifyPreferenceOrderByResourceRoute,
    VerifyPreferenceVisualByResourceRoute,
    VerifyPreferenceSortByResourceRoute,
  } = useGridPreferences();
  const { preferenceTypes } = usePreferenceTypesStore.getState();
  const { columnsPaymentsDetailsAux } = usePaymentDetailsColumns();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [unauthorized, setUnauthorized] = useState(true);
  const [dialogPayment, setDialogPayment] = useState(false);
  const [hiddenHeaderCheckBox, setHiddenHeaderCheckBox] = useState(true);
  const [openDialogView, setOpenDialogView] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [clickedButtonGoBack, setClickedButtonGoBack] = useState(false);
  const [isLoadingDataTable, setIsLoadingDataTable] = useState(false);
  const [backDropLoading, setBackDropLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isLoadedMyLocalPreferences, setIsLoadedMyLocalPreferences] = useState(false);
  const [dataEmails, setDataEmails] = useState<any>([]);
  const [paymentDetailPayload, setPaymentDetailPayload] = useState<PaymentDetail>({});
  const [selectedRows, setSelectedRows] = useState<GridRowsProp>([]);
  const [paymentsDetailsData, setPaymentsDetailsData] = useState<GridRowsProp>([]);
  const [paymentsDetailsDataAll, setPaymentsDetailsDataAll] = useState<GridRowsProp>([]);
  const [mySupplierId, setMySupplierId] = useState(0);
  const [myBusinessName, setMyBusinessName] = useState("");
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [resourcePayments, setResourcePayments] = useState<Menuitem>();
  const [resourceSendEmail, setResourceSendEmail] = useState<Menuitem>();
  const [messageSnack, setMessageSnack] = useState("");
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [myPreferences, setMyPreferences] = useState({});
  const [mySortPreference, setMySortPreference] = useState([]);
  const { GetResourceByUrl } = usePermissions();
  const { GetOperatorToGetDivisa, LoadExchangeRateHistory } = useCurrencies();
  const [companyBalance, setCompanyBalance] = useState({ balance: 0, currency_id: 0, currency_code: "" })
  const [totalPaymentsDetailsData, setTotalPaymentsDetailsData] = useState<GridRowsProp>([]);
  const [comboEnum, setComboEnum] = useState([
    { enum_id: 1, option_name: t("authorizationpayments.comboEnum.all"), route: `/paymentsdetails` },
    { enum_id: 2, option_name: t("authorizationpayments.comboEnum.onlypaid"), route: `/paymentsdetails?filter=${utf8ToBase64(`payment_id!=null`)}` },
    { enum_id: 3, option_name: t("authorizationpayments.comboEnum.onlynopaid"), route: `/paymentsdetails?filter=${utf8ToBase64(`payment_id=null`)}` },
    { enum_id: 4, option_name: t("authorizationpayments.comboEnum.authorized-n-nopaid"), route: `/paymentsdetails?filter=${utf8ToBase64(`payment_id=null&is_authorized=True`)}` },
    { enum_id: 5, option_name: t("authorizationpayments.comboEnum.noauthorized-n-nopaid"), route: `/paymentsdetails?filter=${utf8ToBase64(`payment_id=null&is_authorized=False`)}` },
  ]);
  const [dataCurrencyTable, setDataCurrencyTable] = useState<MyTableCurrencyBanks[]>([]);
  const [columnsPaymentsDetails, setColumnsPaymentsDetails] = useState<GridColDef<PaymentDetail>[]>([]);
  const initFilter = '/paymentsdetails?filter=';
  const defaultFilter = [
    { idFilter: 1, column: "payment_name", operator: "=", value: "" },
    { idFilter: 2, column: "is_authorized", operator: "=", value: "True" },
  ];

  const methodUsed = useCallback(() => {
    switch (location.state.method) {
      case "add":
        {
          showSnackBar(t("generic.snackbar.add"), "success");
          break;
        }
      case "delete":
        {
          showSnackBar(t("generic.snackbar.delete"), "success");
          break;
        }
    }

  }, [location.state, t]);

  const GetTheAmountForSum = async (myRow: any) => {
    if (dataCurrencyTable.length > 0) {
      //BUscar en la tabla de currency de cuentas de banco si hay un banco con la cuenta bancaria
      let currencyEntry = dataCurrencyTable.find((currency) => currency.currency_code === myRow.related_currency_code && currency.active)
      if (!currencyEntry) {
        //Busca el por default que es el MXN
        currencyEntry = dataCurrencyTable.find((currency) => currency.currency_code === "MXN" && currency.active)
        if (!currencyEntry) {
          //Agarra el primero que encuentre
          currencyEntry = dataCurrencyTable.find((currency) => currency.active)
        }
      }
      if (currencyEntry && myRow.related_currency_code === currencyEntry.currency_code) {
        let amountSum = 0;
        if (myRow.current_payment_status_id === 1) {
          amountSum = myRow.amount_outstanding
          currencyEntry.balanceAutorized += amountSum;
          currencyEntry.balanceFree -= amountSum;
        }
      }
      else if (currencyEntry) {
        {
          let exchangeRate = dataCurrencyTable.find((element) => element.currency_code === myRow.related_currency_code)?.exchangeRate ?? 1;
          if (exchangeRate === 1) {
            exchangeRate = await dataCurrencyTable.find((element) => element.currency_code === currencyEntry?.currency_code)?.exchangeRate ?? 1;
          }
          let amountSum = 0;
          if (myRow.current_payment_status_id === 1) {
            let myOperation = await GetOperatorToGetDivisa(currencyEntry.currency_code, myRow.related_currency_code);
            // si es multiply:
            if (myOperation === "multiply") {
              amountSum = myRow.amount_outstanding * exchangeRate
            }
            // si es divide
            else if (myOperation === "divide") {
              amountSum = myRow.amount_outstanding / exchangeRate
            }
            currencyEntry.balanceAutorized += amountSum;
            currencyEntry.balanceFree -= amountSum;
          }
        }
      }
    }
  }

  useEffect(() => {
    const calculateBalance = async () => {
      if (companyBalance.currency_code) {
        try {
          //Setear en 0
          await dataCurrencyTable.map((element) => { element.balanceAutorized = 0; element.balanceFree = element.balanceBankAccount });
          //Sumar autorizadas
          for (const column of totalPaymentsDetailsData) {
            if (column.is_authorized) {
              await GetTheAmountForSum(column);
            }
          }
          setBackDropLoading(false);
        } catch (error) {
          console.error("Error calculating balance:", error);
        }
      }
    };
    if (companyBalance.currency_code.length && totalPaymentsDetailsData) {
      calculateBalance();
    }
  }, [companyBalance, dataCurrencyTable, totalPaymentsDetailsData]);

  const onSendEmail = async () => {
    let myDataEmails: any = [];
    const filteredRows = selectedRows.filter(element => element.payment_id && element.uuid);
    let mySupplier: any;
    if (filteredRows.length > 0) {
      mySupplier = await GenericGetResource(`/suppliers/${filteredRows[0].supplier_id}`);
    }
    filteredRows.forEach((element: any) => {
      let data = {
        data: {
          ...element,
          supplier_email: (mySupplier?.data.supplier_email) ?? '',
          supplier_language: (mySupplier?.data.supplier_language) ?? '',
        },
        status: (mySupplier?.data.supplier_email) ? "Waiting" : "Error",
        status_description: (mySupplier?.data.supplier_email) ? "generic.send_email.waiting" : "generic.send_email.no_email"
      }
      myDataEmails.push(data);
    });
    setDataEmails((prev: any) => myDataEmails);
  }

  const onRowSelection = (rowsIds: GridRowSelectionModel) => {
    if (rowsIds.length === 1) {
      if (hiddenHeaderCheckBox) {
        setPaymentsDetailsDataAll(paymentsDetailsData);
      }
      let myRow = paymentsDetailsData.find(item => item.payment_detail_id === rowsIds[0])

      setMyBusinessName(myRow?.supplier_business_name ?? "");
      setMySupplierId(myRow?.supplier_id ?? 0)
      setPaymentsDetailsData((prev) => prev.filter((item) => item.supplier_id === myRow?.supplier_id &&
        item.supplier_business_name === myRow?.supplier_business_name &&
        item.supplier_bank_account_id === myRow?.supplier_bank_account_id));
      setDataEmails(paymentsDetailsData.filter(payment => rowsIds.includes(payment.payment_detail_id)));
      setHiddenHeaderCheckBox(false);
    }
    else if (rowsIds.length === 0) {
      setPaymentsDetailsData(paymentsDetailsDataAll);
      setDataEmails([]);
      setHiddenHeaderCheckBox(true);
    }
    setSelectedRows((prev) => {
      return paymentsDetailsData.filter(item => rowsIds.includes(item.payment_detail_id));
    });
  }

  let myCustomColumns: GridColDef<any>[] = [
    { field: 'payment_name', headerName: t("payments.fields.payment_name"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'purchase_invoice_name', headerName: t("purchaseinvoices.fields.purchase_invoice_name"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        return <Button onClick={() => {
          let stringConverted = ConvertParamsToBase64(`purchase_invoice_id=${params.row.purchase_invoice_id}&supplier_id=${params.row.supplier_id}`);
          window.open(`/purchaseinvoices/view?${stringConverted}`, '_blank');
        }}>
          {params.row.purchase_invoice_name}
        </Button>
      }
    },
    {
      field: 'project_name', headerName: t("projects.fields.project_name"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        return <Button
          disabled={(params.row.project_name) ? false : true}
          onClick={() => {
            let stringConverted = ConvertParamsToBase64(`project_id=${params.row.project_id}`);
            window.open(`/projects/view?${stringConverted}`, '_blank');
          }}>
          {params.row.project_name}
        </Button>
      }
    },
    {
      field: 'eta', headerName: t("projects.fields.eta"), headerClassName: 'header-grid-table', flex: 1, type: 'date',
      valueGetter(params) {
        return (params.value) ? TimeConverter(params.value) : undefined;
      },
    },
    { field: 'supplier_business_name', headerName: t("purchaseinvoices.fields.supplier_business_name"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'customer_business_name', headerName: t("projects.fields.customer"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'shipping_company', headerName: t("projects.fields.shipping_company"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'related_currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'total_company_currency_amount', headerName: t("companies.configuration.fields.total_company_currency_amount"), headerClassName: 'header-grid-table', flex: 1,
      valueGetter(params) {
        return setFormatNumberFromTable(params.value ?? 0);
      },
    },
    { field: 'user_mail_send', headerName: t("payments.fields.user_mail_send"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'date_mail_send', headerName: t("payments.fields.date_mail_send"), headerClassName: 'header-grid-table', flex: 1, type: 'date',
      valueGetter(params) {
        return (params.value) ? TimeConverter(params.value) : undefined;
      },
    },
  ];

  const loadTablePreferences = async () => {
    // get preferencetypes in Store
    let hasPreferenceOrder: boolean = false;
    // if exists preferencetypes
    if (preferenceTypes.length) {
      // if exists order preferences
      let myPreferencesColumnsOrder = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsOrder");
      if (myPreferencesColumnsOrder) {
        try {
          const preference = await VerifyPreferenceOrderByResourceRoute(
            "/paymentsdetails",
            myPreferencesColumnsOrder.preference_type_id ?? 0
          );
          if (preference) {
            setColumnsPaymentsDetails(await LoadColumnsOrder("/paymentsdetails", myCustomColumns, preference?.preference_value));
            hasPreferenceOrder = true;
          }
        } catch (error) {
          showSnackBar(`Error fetching column order preferences:${error}`, "error");
        }
      }

      let myPreferencesColumnsVisual = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsVisibility");
      // if exists visual preferences
      if (myPreferencesColumnsVisual) {
        try {
          const preference = await VerifyPreferenceVisualByResourceRoute(
            "/paymentsdetails",
            myPreferencesColumnsVisual.preference_type_id ?? 0
          );
          if (preference) {
            let myLocalPreferences = await LoadColumnsVisible("/paymentsdetails", preference);
            setMyPreferences(myLocalPreferences);
          }
        } catch (error) {
          console.error("Error fetching column visual preferences:", error);
        }
      }

      let myPreferencesColumnsSort = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsSorting");
      // if exists sort preferences
      if (myPreferencesColumnsSort) {
        try {
          const preference = await VerifyPreferenceSortByResourceRoute(
            "/paymentsdetails",
            myPreferencesColumnsSort.preference_type_id ?? 0
          );
          if (preference) {
            let myLocalPreferences = await LoadColumnsSort("/paymentsdetails", preference);
            setMySortPreference(myLocalPreferences);
          }
        } catch (error) {
          console.error("Error fetching column sort preferences:", error);
        }
      }

    }
    if (!hasPreferenceOrder) {
      setColumnsPaymentsDetails(columnsPaymentsDetailsAux);
    }
    setIsLoadedMyLocalPreferences(true);
  }

  useEffect(() => {
    setDataLoaded(false);
    GenericGetResourceGeneric("/companies", "/gcompanies").then(async (response) => {
      document.title = `${response.data.data[0].comercial_name} - ${t("paymentsdetails.title")}`;
      if (response.data.data[0].primary_bank_account && response.data.data[0].primary_bank_account > 0) {
        await GenericGetResource(`/bankaccounts/${response.data.data[0].primary_bank_account}`)
          .then((responseBank) => {
            let balanceCompany = {
              balance: responseBank.data.balance,
              currency_id: responseBank.data.currency_id,
              currency_code: responseBank.data.currency_code
            }
            setCompanyBalance(balanceCompany);
          });
      } else {
        showSnackBar(t("authorizationpayments.info.no_primary_bank"), "info");
      }
    })

    if (location.state !== null && location.state.method) methodUsed();
    const fetchData = async () => {
      await loadTablePreferences();
      await LoadExchangeRateHistory()
        .catch((error: unknown) => {
          if (error instanceof AxiosError) {
            if (error.response && error.response.status === 400) {
              showSnackBar(error.response.data, "error");
            } else {
              showSnackBar(error.message, "error");
            }
          } else {
            showSnackBar("An unexpected error occurred", "error");
          }
        });
      GenericGetResource(comboEnum[0].route)
        .then(async (response) => {
          setTotalPaymentsDetailsData(response.data.data);
        }
        ).catch((error) => {
          setMessageSnack(error.message);
          showSnackBar(error.message, "error");
          setUnauthorized(false);
        });

      let myPermissions = [
        GetResourceByUrl(`/payments`),
        GetResourceByUrl(`/paymentsdetails`),
        GetResourceByUrl(`/paymentsdetails/sendemail`),
      ]
      Promise.all(myPermissions)
        .then((responses) => {
          setResourcePayments((prev) => responses[0]);
          setResourceScreen((prev) => responses[1]);
          setResourceSendEmail((prev) => responses[2]);
          setDataLoaded(true);
        })
        .catch((error) => {
          setMessageSnack(error.message);
          showSnackBar(error.message, "error");
          setUnauthorized(false);
        });
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedButtonGoBack]);

  useEffect(() => {
    if (isLoadedMyLocalPreferences && paymentsDetailsData) {
      setDataLoaded(true);
      setIsLoadingDataTable(true);
    }
  }, [paymentsDetailsData, isLoadedMyLocalPreferences]);

  useEffect(() => { }, [hiddenHeaderCheckBox]);

  useEffect(() => { }, [backDropLoading]);

  return (
    <>
      {!unauthorized && <ErrorDisplay errorMessage={messageSnack} />}
      {unauthorized && !dataLoaded && <Spinner />}
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={backDropLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
      {dataLoaded && resourceScreen?.read &&
        <div className='screen-container'>
          <Header
            title={t("paymentsdetails.title")}
            size="no_title"
            child={
              <>
                <TableCurrencyCompany
                  resourceScreen={resourceScreen}
                  dataCurrencyTable={dataCurrencyTable}
                  setDataCurrencyTable={setDataCurrencyTable}
                  setBackDropLoading={setBackDropLoading}
                  setMessageSnack={setMessageSnack}
                  setUnauthorized={setUnauthorized}
                  showSnackBar={showSnackBar}
                />
                <div className="w-100 d-flex flex-row mt-2 align-items-center">
                  <div className="w-50 mt-2">
                    <h3>{t("paymentsdetails.title")}</h3>
                  </div>
                  <div className="w-50">
                    <div className="d-flex flex-row-reverse">
                      <PrimaryButton size="small" variant='outlined' className="m-1" sx={{ color: 'primary.main' }} disabled={(selectedRows?.length === 0) || !resourcePayments?.create} onClick={() => setDialogPayment(true)}>
                        {t("paymentsdetails.buttons.apply-payment")}<MoneyIcon sx={{ marginLeft: 1 }} />
                      </PrimaryButton>
                      {resourceSendEmail?.create === true &&
                        <ButtonStyled size="small" variant='outlined' className="m-1" sx={{ color: 'primary.main' }} disabled={selectedRows.length === 0} onClick={async () => { await onSendEmail(); setOpenEmail(true); }}>
                          {t("generic.buttons.send_email")}<EmailIcon sx={{ marginLeft: 1 }} />
                        </ButtonStyled>
                      }
                      <FilterTable
                        setIsLoadingDataTable={setIsLoadingData}
                        setDataTable={setPaymentsDetailsData}
                        showSnackBar={showSnackBar}
                        columnsTable={columnsPaymentsDetails}
                        initFilter={initFilter}
                        resourceRoute="/paymentsdetails"
                        defaultFilter={defaultFilter}
                      />
                    </div>
                  </div>
                </div>
              </>
            }
          />
          <div className="d-flex justify-content-center mt-2">
            {isLoadingDataTable &&
              <Box sx={{ height: 'calc(100vh - 260px)', width: '100%' }}>
                <DataTableSticky
                  isLoading={isLoadingData}
                  columns={columnsPaymentsDetails}
                  setColumns={setColumnsPaymentsDetails}
                  data={paymentsDetailsData ?? []}
                  entityId={"payment_detail_id"}
                  entity={`PaymentsDetails`}
                  preferences={myPreferences}
                  namePreferences={"/paymentsdetails"}
                  nameOrderColumns={"/paymentsdetails"}
                  selectRows
                  hiddenHeaderCheckBox={hiddenHeaderCheckBox}
                  onRowSelectionModelChange={(rowsIds) => onRowSelection(rowsIds)}
                  isChildren
                  countColumns={[
                    "total_company_currency_amount",
                    "total_tax_amount",
                    "total_retention_amount",
                    "subtotal_amount",
                    "total_amount",
                    "total_company_currency_amount",
                    "payment_amount",
                    "amount_outstanding",
                  ]}
                  sortPreference={mySortPreference}
                  setOpenDialog={setOpenDialogView}
                  setDataRow={setPaymentDetailPayload}
                  conditionalOpenRow={`payment_id`}
                />
              </Box>
            }
          </div>
          <DialogEntity
            open={openDialogView}
            setOpen={setOpenDialogView}
            title={
              <></>
            }
            fullWidth
            content={
              <ViewPaymentDetails
                paymentDetailPayload={paymentDetailPayload}
                permissionsPaymentsDetails={resourceScreen}
                permissionsPayments={resourcePayments}
                setOpenDialogView={setOpenDialogView}
                setClickedButtonGoBack={setClickedButtonGoBack}
              />
            }
          />
          <DialogEntity
            open={dialogPayment}
            title={<></>}
            fullWidth={true}
            content={
              <DialogPayment
                setSelectedRows={setSelectedRows}
                rows={paymentsDetailsData.filter((item) => !item.payment_name)}
                supplier_id={mySupplierId}
                businessName={myBusinessName}
                selectedRows={selectedRows}
                setDialogPayment={setDialogPayment}
                setClickedButtonGoBack={setClickedButtonGoBack}
                myParentColumns={columnsPaymentsDetails}
                myParentPreferences={myPreferences}
              />
            }
          />
          <DialogSendEmailsTable
            open={openEmail}
            setOpen={setOpenEmail}
            dataPaymentsDetailsSelected={dataEmails}
            showSnackBar={showSnackBar}
          />
          <SnackbarComponent />

        </div>
      }
    </>
  )
}
